module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec01_b9f432b5033c20db1afa7c993e6a24c1.jpg";